import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import { ReactComponent as ExternalLinkIcon } from 'images/icons/icon-popout.svg';
import { TERMS_AND_CONDITIONS_URL } from 'modules/chatbot/constants/constants';
import styles from './termsOfServiceModal.module.less';

interface TermsOfServiceModalProps {
  visible: boolean;
  onAccept: () => void;
  onClose: () => void;
}

const TermsOfServiceModal: React.FC<TermsOfServiceModalProps> = ({
  visible,
  onAccept,
  onClose,
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (visible) {
      setShouldRender(true);
      setIsClosing(false);
    } else if (shouldRender) {
      setIsClosing(true);
      // Wait for animation to complete before hiding
      const timer = setTimeout(() => {
        setShouldRender(false);
        setIsClosing(false);
      }, 300); // Match animation duration
      return () => clearTimeout(timer);
    }
  }, [visible, shouldRender]);

  const handleOverlayClick = (e: React.MouseEvent) => {
    // Do nothing when clicking on the backdrop - user must accept or close
    if (e.target === e.currentTarget) {
      // Optionally, we could call onClose here, but based on requirements, do nothing
    }
  };

  if (!shouldRender) {
    return null;
  }

  return (
    <div
      className={`${styles.overlay} ${isClosing ? styles.closing : ''}`}
      onClick={handleOverlayClick}
    >
      <div className={styles.modal}>
        <div className={styles.content}>
          <h2 className={styles.title}>Terms of Service</h2>
          <div className={styles.description}>
            <p className={styles.descriptionLine}>
              Please review and accept our
            </p>
            <p className={styles.descriptionLine}>
              <a
                href={TERMS_AND_CONDITIONS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                Terms & Conditions
                <ExternalLinkIcon className={styles.externalIcon} />
              </a>{' '}
              and{' '}
              <a
                href={TERMS_AND_CONDITIONS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                Privacy Policy
                <ExternalLinkIcon className={styles.externalIcon} />
              </a>
            </p>
            <p className={styles.descriptionLine}>to continue.</p>
          </div>
          <div className={styles.actions}>
            <Button
              type="primary"
              className={styles.acceptButton}
              onClick={onAccept}
            >
              Accept
            </Button>
            <Button className={styles.closeButton} onClick={onClose}>
              Close
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServiceModal;
